import {
  GET_SURVEY_TEMPLATE_QUESTION_ITEMS,
  FETCH_SURVEY_TEMPLATE_QUESTION_ITEM,
  ADD_SURVEY_TEMPLATE_QUESTION_ITEM,
  UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM,
  DELETE_SURVEY_TEMPLATE_QUESTION_ITEM,
  CLEAR_SURVEY_TEMPLATE_QUESTION_ITEMS,
  SURVEY_TEMPLATE_QUESTION_ITEMS_PAGE,
  CLEAR_ALL,
  SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  survey_template_question_items: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function surveyTemplateQuestionItems(state = initialState, action) {
  switch (action.type) {
    case SURVEY_TEMPLATE_QUESTION_ITEMS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_SURVEY_TEMPLATE_QUESTION_ITEMS:
      return {
        ...state,
        survey_template_question_items: action.payload,
        pending: false,
      };
    case SURVEY_TEMPLATE_QUESTION_ITEMS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SURVEY_TEMPLATE_QUESTION_ITEM:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SURVEY_TEMPLATE_QUESTION_ITEM:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_SURVEY_TEMPLATE_QUESTION_ITEM:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_SURVEY_TEMPLATE_QUESTION_ITEM:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_SURVEY_TEMPLATE_QUESTION_ITEMS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}